// extracted by mini-css-extract-plugin
export default {"productcard":"bQ","productimage":"cQ","username":"eQ","multiBagName":"fQ","productinfo":"gQ","productinfoinner":"hQ","productname":"iQ","productsubheader":"jQ","productdescription":"kQ","productnumbers":"lQ","productnumberstitle":"mQ","productnumbersitem":"nQ","number":"oQ","numbertext":"pQ","tabs":"qQ","benefitsblock":"rQ","benefit":"sQ","benefitname":"tQ","benefitdescription":"uQ","ingredientsblock":"vQ","tipsblock":"wQ","mobileonly":"xQ"};
    if(module.hot) {
      // 1715188238009
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  